<div class="mx-auto max-w-lg">
    <div>
        <div class="text-center">
            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 48 48" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M34 40h10v-4a6 6 0 00-10.712-3.714M34 40H14m20 0v-4a9.971 9.971 0 00-.712-3.714M14 40H4v-4a6 6 0 0110.713-3.714M14 40v-4c0-1.313.253-2.566.713-3.714m0 0A10.003 10.003 0 0124 26c4.21 0 7.813 2.602 9.288 6.286M30 14a6 6 0 11-12 0 6 6 0 0112 0zm12 6a4 4 0 11-8 0 4 4 0 018 0zm-28 0a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <h2 class="mt-4 text-xl font-semibold font-header leading-6 text-gray-900">Het is stil hier.</h2>
            <p class="mt-4 text-sm text-gray-500">
                Geen vestigingen gevonden. Maak er een aan om te beginnen.
            </p>
        </div>
        <div class="flex justify-center mt-6">
            <app-add-button
                (click)="createEstablishment()"
            />
        </div>
    </div>
</div>
